<template>
  <available-components-for-theme9 :specific-components="components" />
</template>
<script lang="ts">
import AvailableComponentsForTheme9 from '~/components/theme9/AvailableComponentsForTheme9.vue';
import { ViewsMixin } from '~/mixins/views.mixin';

export default defineNuxtComponent({
  name: 'Theme9View',

  mixins: [ViewsMixin],

  components: {
    AvailableComponentsForTheme9,
  },

  description:
    'Components that can be used through this theme should be imported here in order to use them dynamically',
});
</script>
